import { useEffect, useState } from "react";
import { drainQueue, pendingOpsCount, subscribe } from "@/lib/offlineStore";

export function useOnlineStatus() {
  const [online, setOnline] = useState(() => (typeof navigator !== "undefined" ? navigator.onLine : true));
  const [pending, setPending] = useState(() => pendingOpsCount());

  useEffect(() => {
    const onOnline = async () => {
      setOnline(true);
      try { await drainQueue(); } catch {}
      setPending(pendingOpsCount());
    };
    const onOffline = () => setOnline(false);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    const unsub = subscribe(() => setPending(pendingOpsCount()));
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
      unsub();
    };
  }, []);

  return { online, pending };
}
